import Keycloak from "keycloak-js";

export const keycloakClient = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID,
});

export const keycloakInitConfiguration = {
    onLoad: "login-required",
    checkLoginIframe: false
}